// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function tr<T extends Record<string, string>>(
  key: keyof T,
  staticText: T,
  replacements?: Record<string, string>,
  count?: number,
): string {
  // Get the translation, using fallback if necessary
  let translation = String(staticText[key] || key);

  // Handle plurals if count is provided
  if (count !== undefined) {
    const [singular, plural] = translation.split('|');
    translation = count === 1 ? singular : plural;
  }

  // Replace variables in the translation string
  if (replacements) {
    for (const [placeholder, value] of Object.entries(replacements)) {
      translation = translation.replace(
        new RegExp(`:${placeholder}`, 'g'),
        value,
      );
    }
  }

  return translation;
}
